// extracted by mini-css-extract-plugin
module.exports = {"full__screen__page":"full__screen__page___3VQkr","full__screen__page__flow":"full__screen__page__flow___b7VsT"};
    if(module.hot) {
      // 1677682834791
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  